export const informationalAlertHealth: Record<
  string,
  Record<string, string>
> = {
  agents: {
    vaccinesCard:
      'Sem o cartão de vacina, a criança não poderá se imunizar, ficando vulnerável a doenças.',
    vaccinesUpToDate:
      'Com o cartão de vacina desatualizado, a criança pode não estar completamente imunizada contra doenças.',
  },

  cadunico: {
    disability:
      'É importante que crianças com deficiência tenham assistência à saúde para uma melhor qualidade de vida.',
  },
}

export const informationalAlertEducation: Record<
  string,
  Record<string, string>
> = {
  cadunico: {
    currentCourse:
      'Crianças devem estar matriculadas em uma instituição de ensino.',
  },
  agents: {
    currentCourse:
      'Crianças devem estar matriculadas em uma instituição de ensino.',
  },
}

export const informationalAlertNutrition: Record<
  string,
  Record<string, string>
> = {
  agents: {
    food: 'A falta de uma alimentação minimamente saudável e regular é um problema grave.',
    meal: 'A falta de uma alimentação minimamente saudável e regular é um problema grave.',
    consumption:
      'A falta de uma alimentação minimamente saudável e regular é um problema grave.',
  },
}

export const informationalAlertIncome: Record<
  string,
  Record<string, Record<string, string>>
> = {
  cadunico: {
    family: {
      hasChildLabor:
        'Trabalho infantil pode prejudicar o desenvolvimento da criança.',
      totalExpense:
        'Gastos maiores que ganhos prejudicam a qualidade de vida da família.',
    },
    members: {
      childLabor:
        'Trabalho infantil pode prejudicar o desenvolvimento da criança.',
    },
  },
  agents: {
    family: {
      sourceOfIncome:
        'Sem fonte de renda, a família corre alto risco de não suprir suas necessidades básicas.',
      someoneWorks:
        'Sem alguém que trabalhe, a renda familiar pode estar gravemente comprometida.',
    },
  },
}

export const informationalAlertResidence: Record<
  string,
  Record<string, string>
> = {
  agents: {
    drinkableWater: 'Ter acesso à água tratada e própria para beber é vital.',
    waterSupply:
      'Ter uma fonte de abastecimento de água tratada e própria para o consumo é vital.',
    garbageCollectionFrequency:
      'Estar integrado a uma rede de coleta de lixo ajuda a manter o ambiente limpo e saudável.',
    formOfLighting: 'Essa forma de iluminação pode causar acidentes graves.',
  },
  cadunico: {
    waterSupply:
      'Ter uma fonte de abastecimento de água tratada e própria para o consumo é vital.',
    garbageDisposal:
      'Descartar o lixo de forma incorreta pode prejudicar o ambiente e causar doenças.',
    formOfLighting: 'Essa forma de iluminação pode causar acidentes graves.',
    hasBathroom:
      'A falta de um local apropriado para tratar os dejetos humanos pode causar problemas de saúde.',
    paving: 'O contato direto com o solo pode causar doenças.',
    sanitaryDrainage:
      'Descartar os dejetos de forma incorreta pode prejudicar o ambiente e causar doenças.',
    wallsMaterial:
      'Material pouco resistente para a construção de uma casa pode acarretar em acidentes graves.',
    floorMaterial: 'O contato direto com o solo de terra pode causar doenças.',
  },
}
